import Tables from 'src/class/Tables';
import i18n from 'src/i18n'

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 160,
      sortable: true,
      align: 'center',
      fixed: true,
    },
    {
      prop: 'user_name',
      label: i18n.t('common_words.user'),
      minWidth: 160,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'evaluation_name',
      label: i18n.t('common_words.evaluation'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'type_calification',
      label: i18n.t('audit.audit_type'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'type_inspection_label',
      label: i18n.t('common_words.evaluation_type'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'date_save',
      label: i18n.t('common_words.save_date'),
      minWidth: 180,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'week_save',
      label: i18n.t('common_words.week'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'day_save',
      label: i18n.t('common_words.day'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observations'),
      minWidth: 200,
      sortable: true,
    },
  ];



  const TableDetails = { ...Tables.Table };
  TableDetails.tableColumns = [
    {
      prop: 'latitude',
      label: i18n.t('common_words.latitude'),
    },
    {
      prop: 'longitude',
      label: i18n.t('common_words.longitude'),
    },
    {
      prop: 'altitude',
      label: i18n.t('common_words.altitude'),
    },
    {
      prop: 'name_subcategory',
      label: i18n.t('common_words.sub_category_unique'),
    },
    {
      prop: 'audit_task_with_trashed.name',
      label: i18n.t('common_words.task'),
    },
    {
      prop: 'setValue',
      label: i18n.t('common_words.accomplishment_or_grade'),
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observations'),
    },
  ];



  const searchDetails = {

    pagedDataDetails() {
      return this.tableDataDetails.slice(this.fromDetails, this.toDetails);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataDetails() {
      let result = this.tableDataDetails;
      if (this.searchQueryDetails !== '') {
        result = this.fuseSearchDetails.search(
          '=' + this.searchQueryDetails + ''
        );
      }
      this.paginationDetails.total = result.length;
      return result.slice(this.fromDetails, this.toDetails);
    },
    toDetails() {
      let highBound = this.fromDetails + this.paginationDetails.perPage;
      if (this.totalDetails < highBound) {
        highBound = this.totalDetails;
      }
      return highBound;
    },
    fromDetails() {
      return (
        this.paginationDetails.perPage *
        (this.paginationDetails.currentPage - 1)
      );
    },
    totalDetails() {
      // this.paginationDetails.totalDetails = this.tableDataDetails.length;
      return this.paginationDetails.total;
    },
  };

  return { Table, searchDetails, TableDetails };

};

export default configTable;

